<template>
	<div class="max-w-7xl px-6 md:px-0 mx-auto z-30 relative">
		<div class="grid md:w-screen grid-cols-1 md:grid-cols-2">
			<div
				class="bg-white mt-16 h-full p-10 bg-cover rounded-l-lg bg-top -mr-6"
				style="background-image:url(images/assets/bucharest.png)"
			>

				<h1 class="font-gilroy-extrabold text-black text-6xl block">We're here</h1>
				<div class="mt-16 md:mt-36 grid grid-cols-2 md:grid-cols-2 gap-4">

					<div class="bg-white rounded px-4 py-2 shadow-lg">
						<span class="block font-gilroy-extrabold text-lg">Focsani Office</span>
						<span class="block font-roboto-regular">9 Unirii Blvd.</span>
						<span class="block font-roboto-regular">Focsani, Vrancea</span>
						<span class="block font-roboto-regular">Romania</span>
					</div>

					<div class="bg-white rounded px-4 py-2 shadow-lg">
						<span class="block font-gilroy-extrabold text-lg">Bucharest Office</span>
						<span class="block font-roboto-regular">76 Unirii Blvd.</span>
						<span class="block font-roboto-regular">District 3, Bucharest</span>
						<span class="block font-roboto-regular">Romania</span>
					</div>
				</div>
			</div>
			<div
				v-bind:class="{ bigger: contactOption }"
				class="bg-gradient-to-br from-purple-400 max-h-full to-purple-600 mt-16 max-h-max shadow-lg h-full hover:scale-115 transition transform duration-500 p-10 rounded-l-lg"
			>

				<transition
					name="slide-fade"
					mode="out-in"
				>
					<div
						v-show="optionsShown == false"
						key="1"
					>
						<h1 class="font-gilroy-extrabold text-white text-6xl">Let's talk</h1>

						<ul class="mt-16 md:mt-18 list-none">
							<li class="block mb-2">
								<label>
									<input
										@change="furtherContact($event, contactOption)"
										v-model="contactOption"
										type="radio"
										name="reason"
										id="video-call"
										value="1"
										class="white"
									>

									<span class="text-white text-inter-500">Careers</span>
								</label>
							</li>
							<li class="block mb-2">
								<label>
									<input
										@change="furtherContact($event, contactOption)"
										v-model="contactOption"
										type="radio"
										name="reason"
										id="video-call"
										value="2"
										class="white"
									>

									<span class="text-white text-inter-500">Craft your product</span>
								</label>
							</li>
							<li class="block mb-2">
								<label>
									<input
										@change="furtherContact($event, contactOption)"
										v-model="contactOption"
										type="radio"
										name="reason"
										id="video-call"
										value="3"
										class="white"
									>

									<span class="text-white text-inter-500">Sponsorship/partnership</span>
								</label>
							</li>
						</ul>

						<a
							href="#"
							class="mt-12 transition duration-500 rounded-full block p-2 h-12 w-12 border-2 border-white hover:border-green-400 hover:bg-green-400"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="#fff"
								viewBox="0 0 24 24"
								stroke="#fff"
								class="mt-0 hover:text-black inline-block"
								id="contactbtn"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M14 5l7 7m0 0l-7 7m7-7H3"
								></path>
							</svg>
						</a>
					</div>
				</transition>
				<transition-group
					name="slide-fade"
					mode="out-in"
				>
					<div
						v-show="optionsShown == 1"
						key="2"
						class="max-w-7xl"
					>
						<div class="flex items-center justify-center">
							<div class="w-1/12">
								<span
									@click="optionsShown = false; contactOption = null"
									class="transition cursor-pointer duration-500 rounded-full inline-block p-2 h-12 w-12 border-2 border-white hover:border-green-400 hover:bg-green-400"
								>

									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke="#fff"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M10 19l-7-7m0 0l7-7m-7 7h18"
											class="mt-0 hover:text-black inline-block text-white"
										/>
									</svg>
								</span>
							</div>

							<div class="w-11/12">
								<h1 class="text-5xl text-white font-gilroy-extrabold inline-block mb-1">Would you join The Cloud?</h1>
							</div>
						</div>

						<div class="mt-20">
							Unfortunately, we do not hire right now.
						</div>
					</div>

					<div
						v-show="optionsShown == 2"
						key="3"
						class="max-w-7xl"
					>
						<div class="flex items-center justify-center">
							<div class="w-2/12 md:w-1/12">
								<span
									@click="optionsShown = false; contactOption = null"
									class="transition cursor-pointer duration-500 rounded-full inline-block p-2 h-8 w-8 md:h-12 md:w-12 border-2 border-white hover:border-green-400 hover:bg-green-400"
								>

									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke="#fff"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M10 19l-7-7m0 0l7-7m-7 7h18"
											class="mt-0 hover:text-black inline-block text-white"
										/>
									</svg>
								</span>
							</div>

							<div class="w-10/12 md:w-11/12">
								<h1 class="text-3xl md:text-5xl text-white font-gilroy-extrabold inline-block mb-1">Estimate your project</h1>
							</div>
						</div>

						<transition
							name="slide-fade"
							mode="in-out"
						>
							<div
								v-if="errors"
								class="mt-12"
							>
								<div
									v-for="error in errors"
									v-bind:key="error"
									class="bg-gradient-to-br from-red-400 to-red-500 rounded max-w-xl p-5 rounded-md text-white text-inter-400"
								>
									<span>{{error}}</span>
								</div>
							</div>
							<div
								v-if="sentSuccess"
								class="mt-12"
							>
								<div class="bg-gradient-to-br from-green-400 to-green-500 rounded max-w-xl p-5 rounded-md text-white text-inter-400">
									<span>Your inquiry has been recorded successfully. We'll review as soon as possible and reach back. Thanks! 🎉</span>
								</div>
							</div>
						</transition>

						<div class="mt-20 flex flex-col md:flex-row">
							<div class="w-12/12 md:w-3/12">
								<h1 class="text-3xl font-gilroy-extrabold text-white">Timeframe</h1>
								<ul class="mt-4 block list-none">
									<li class="block">
										<label>
											<input
												v-model="forms.timeframe"
												type="radio"
												name="reason"
												value="Under 1 month"
												class="white"
											>

											<span class="text-white"> &lt; 1 month</span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.timeframe"
												type="radio"
												name="reason"
												value="1 - 3 months"
												class="white"
											>

											<span class="text-white"> 1 - 3 months</span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.timeframe"
												type="radio"
												name="reason"
												value="3 - 6 months"
												class="white"
											>

											<span class="text-white"> 3 - 6 months</span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.timeframe"
												type="radio"
												name="reason"
												value="6 - 12 months"
												class="white"
											>

											<span class="text-white"> 6 - 12 months</span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.timeframe"
												type="radio"
												name="reason"
												value="More than 12 months"
												class="white"
											>

											<span class="text-white"> &gt; 12 months</span>
										</label>
									</li>
								</ul>
							</div>
							<div class="w-12/12 mt-12 md:mt-0 md:w-3/12">
								<h1 class="text-3xl font-gilroy-extrabold text-white">Project type</h1>
								<ul class="mt-4 block list-none">
									<li class="block">
										<label>
											<input
												v-model="forms.type.web"
												type="checkbox"
												value="Web"
												class="white inline-block"
											>

											<span class="text-white inline-block"> Web </span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.type.mobile"
												type="checkbox"
												value="Mobile"
												class="white inline-block"
											>

											<span class="text-white inline-block"> Mobile </span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.type.desktop"
												type="checkbox"
												value="Desktop"
												class="white inline-block"
											>

											<span class="text-white inline-block"> Desktop </span>
										</label>
									</li>
									<li class="block">
										<label>
											<input
												v-model="forms.type.other"
												type="checkbox"
												value="Other"
												class="white inline-block"
											>

											<span class="text-white inline-block"> Other </span>
										</label>
									</li>
								</ul>
							</div>
							<div class="w-12/12 mt-12 md:mt-0 md:w-6/12">
								<h1 class="text-3xl font-gilroy-extrabold text-white">Details</h1>
								<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
									<div>
										<input
											v-model="forms.details.name"
											class="bg-purple-400 px-2 py-3 text-white w-full placeholder-white mb-4"
											placeholder="Name"
										>

										<input
											v-model="forms.details.company"
											class="bg-purple-400 px-2 py-3 text-white w-full placeholder-white mb-4"
											placeholder="Company"
										>

										<input
											v-model="forms.details.email"
											class="bg-purple-400 px-2 py-3 text-white w-full placeholder-white mb-4"
											placeholder="Email"
										>

										<input
											v-model="forms.details.budget"
											class="bg-purple-400 px-2 py-3 text-white w-full placeholder-white"
											placeholder="Budget (EUR)"
										>
									</div>
									<div>
										<textarea
											v-model="forms.details.description"
											class="bg-purple-400 px-2 py-3 h-full resize-none text-white w-full placeholder-white mb-2"
										></textarea>
									</div>
								</div>
								<button
									@click="sendInquiry()"
									class="rounded-full px-10 border hover:bg-white hover:text-black transition duration-500 mt-4 float-right border-white text-white p-2"
								>Send inquiry</button>
							</div>
						</div>
					</div>

					<div
						v-show="optionsShown == 3"
						key="4"
					>
						<div class="flex items-center justify-center">
							<div class="w-1/12">
								<span
									@click="optionsShown = false; contactOption = null"
									class="transition cursor-pointer duration-500 rounded-full inline-block p-2 h-12 w-12 border-2 border-white hover:border-green-400 hover:bg-green-400"
								>

									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke="#fff"
									>
										<path
											stroke-linecap="round"
											stroke-linejoin="round"
											stroke-width="2"
											d="M10 19l-7-7m0 0l7-7m-7 7h18"
											class="mt-0 hover:text-black inline-block text-white"
										/>
									</svg>
								</span>
							</div>

							<div class="w-11/12">
								<h1 class="text-5xl text-white font-gilroy-extrabold inline-block mb-1">New partners?</h1>
							</div>
						</div>

						<div class="mt-20">
							<span class="text-inter-400 text-lg text-white">We'd love to discuss this matter on email.<br>Please write an email containing your proposal to <b>contact [at] codestage [dot] ro</b>.</span>
						</div>
					</div>
				</transition-group>
			</div>
		</div>
	</div>
</template>

<style>
.bigger {
	transition: all 1s ease-out;
	transform: translateX(0);
}

@media screen and (min-width: 768px) {
	body {
		overflow-x: hidden;
	}
	.bigger {
		transition: all 1s ease-out;
		transform: translateX(-50%);
		width: 100vw;
	}
}
.slide-fade-enter-active {
	transition: all 1.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
	transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(110px);
	opacity: 0;
}
</style>

<script>
/*import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
Vue.use(SequentialEntrance);
https://vuejsexamples.com/vuejs-plugin-for-creating-epic-sequential-animation-entrances/
*/

export default {
	methods: {
		furtherContact: function (e, variant) {
			this.optionsShown = variant;
			switch (variant) {
				case "1":
					this.optionsShown = 1;
					break;

				case "2":
					break;

				case "3":
					break;
			}
		},
		sendInquiry() {

			this.errors = [];
			this.forms.formated_type = null;

			if (this.forms.type.web !== null) (this.forms.formated_type !== null && this.forms.formated_type.length > 0) ? this.forms.formated_type += "Web; " : this.forms.formated_type = "Web; ";
			if (this.forms.type.mobile !== null) (this.forms.formated_type !== null && this.forms.formated_type.length > 0) ? this.forms.formated_type += "Mobile; " : this.forms.formated_type = "Mobile; ";
			if (this.forms.type.desktop !== null) (this.forms.formated_type !== null && this.forms.formated_type.length > 0) ? this.forms.formated_type += "Desktop; " : this.forms.formated_type = "Desktop; ";
			if (this.forms.type.other !== null) (this.forms.formated_type !== null && this.forms.formated_type.length > 0) ? this.forms.formated_type += "Other; " : this.forms.formated_type = "Other; ";

			let $this = this;
			var xhttp = new XMLHttpRequest();
			xhttp.onreadystatechange = function () {
				if (this.readyState == XMLHttpRequest.DONE && this.status == 200) {
					let response = JSON.parse(this.response);
					if (response.status == "success") {
						$this.sentSuccess = true;
					} else {
						$this.errors.push(response.message);
					}
				}
			};
			xhttp.open("POST", "http://vue.codestage.ro/inquirer.php", true);
			xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhttp.send("timeframe=" + this.forms.timeframe + "&type=" + this.forms.formated_type + "&name=" + this.forms.details.name + "&email=" + this.forms.details.email + "&company=" + this.forms.details.company + "&description=" + this.forms.details.description);
		}
	},
	data() {
		return {
			contactOption: null,
			optionsShown: false,
			forms: {
				formated_type: null,
				timeframe: null,
				type: {
					web: null,
					mobile: null,
					desktop: null,
					other: null
				},
				details: {
					name: null,
					email: null,
					company: null,
					description: null
				}
			},
			errors: [],
			sentSuccess: false
		}
	}
}
</script>